export const convertBytesToMB = (bytes: Number) => (Number(bytes) / (1024 * 1024));

export const IMAGE_PER_PAGE = 20;

export const supportedImageTypes: string[] = [
  'image/webp'
]

export const allowedImageRegex: RegExp = /^webp/i

export const acceptedImageTypes = supportedImageTypes.join(', ')